/* Soap Glass shaders and palettes for A Good Bar of Soap. Loaded before soap-glass.js. */
window.SoapGlassShaders = function (ASPECT, PALETTE) {
const MARBLE_SHOP = `vec3 pal(float r, float x){ float m = mod(x,5.), k = mod(r,6.);
  if(k<0.5){ if(m<0.5) return vec3(0.424,0.310,0.525); if(m<1.5) return vec3(0.941,0.847,0.290); if(m<2.5) return vec3(0.659,0.267,0.369); if(m<3.5) return vec3(0.557,0.435,0.659); return vec3(0.424,0.310,0.525); }
  if(k<1.5){ if(m<0.5) return vec3(0.553,0.729,0.306); if(m<1.5) return vec3(0.914,0.788,0.627); if(m<2.5) return vec3(0.557,0.647,0.353); if(m<3.5) return vec3(0.722,0.824,0.478); return vec3(0.553,0.729,0.306); }
  if(k<2.5){ if(m<0.5) return vec3(0.910,0.784,0.306); if(m<1.5) return vec3(0.561,0.647,0.416); if(m<2.5) return vec3(0.878,0.478,0.310); if(m<3.5) return vec3(0.663,0.737,0.471); return vec3(0.561,0.647,0.416); }
  if(k<3.5){ if(m<0.5) return vec3(0.420,0.435,0.502); if(m<1.5) return vec3(0.945,0.941,0.933); if(m<2.5) return vec3(0.227,0.239,0.290); if(m<3.5) return vec3(0.890,0.886,0.871); return vec3(0.604,0.620,0.675); }
  if(k<4.5){ if(m<0.5) return vec3(0.910,0.831,0.604); if(m<1.5) return vec3(0.949,0.890,0.722); if(m<2.5) return vec3(0.898,0.796,0.525); if(m<3.5) return vec3(0.965,0.922,0.784); return vec3(0.863,0.761,0.529); }
  if(k<5.5){ if(m<0.5) return vec3(0.788,0.608,0.306); if(m<1.5) return vec3(0.431,0.290,0.388); if(m<2.5) return vec3(0.910,0.812,0.580); if(m<3.5) return vec3(0.431,0.290,0.388); return vec3(0.549,0.369,0.431); }
  return vec3(1.); }
vec3 sprink(float h){ if(h<0.20) return vec3(0.890,0.416,0.541); if(h<0.40) return vec3(0.231,0.714,0.651); if(h<0.60) return vec3(0.290,0.482,0.784); if(h<0.80) return vec3(0.941,0.541,0.235); return vec3(0.541,0.357,0.690); }
vec3 recipe(float r, float L){
  float i0 = floor(L), fr = fract(L);
  return mix(pal(r,i0), pal(r,i0+1.), smoothstep(.80,.97,fr));
}
vec3 marble(vec2 uv, float t){
  vec2 p = vec2(uv.x*${ASPECT.toFixed(4)}, uv.y)*1.9;
  vec2 q = vec2(fbm(p+vec2(0.,t)), fbm(p+vec2(5.2,1.3)-t));
  vec2 r = vec2(fbm(p+3.*q+vec2(1.7,9.2)+.3*t), fbm(p+3.*q+vec2(8.3,2.8)));
  float f = fbm(p+2.6*r);
  float L = uv.y*3.6 + uv.x*1.3 + (f-.5)*5.2 + (r.x-.5)*2.2;
  float RG = uv.x*2.9 + (q.y-.5)*2.2 + t*.3;
  float r0 = floor(RG), rb = smoothstep(.82,.98,fract(RG));
  vec3 col = mix(recipe(r0,L), recipe(r0+1.,L), rb);
  float vein = 1. - smoothstep(0., .045, abs(fract(f*9.+r.y*2.3)-.5));
  col = mix(col, vec3(.97,.955,.86), vein*.6);
  float conf = (mod(r0,6.)==4. ? 1.-rb : 0.) + (mod(r0+1.,6.)==4. ? rb : 0.);
  vec2 sp2 = vec2(uv.x*${ASPECT.toFixed(4)}, uv.y)*95.;
  vec2 cell = floor(sp2); vec2 fc = fract(sp2) - .5;
  float h1 = hash(cell + 3.1), h2 = hash(cell + 9.7);
  float ang = h2*6.283; vec2 dir = vec2(cos(ang), sin(ang));
  float along = dot(fc, dir), across = dot(fc, vec2(-dir.y, dir.x));
  float bit = step(.80, h1) * step(abs(along), .30) * step(abs(across), .09);
  return mix(col, sprink(fract(h1*7.3)), bit*conf);`;
const MARBLE_CLASSIC = `vec3 pal(float x){ float m = mod(x,5.);
  if(m<.5) return vec3(.247,.749,.635);   // teal
  if(m<1.5) return vec3(.949,.933,.784);  // cream
  if(m<2.5) return vec3(.494,.439,.659);  // lavender
  if(m<3.5) return vec3(.576,.702,.620);  // sage
  return vec3(.886,.533,.486); }          // clay
vec3 marble(vec2 uv, float t){
  vec2 p = vec2(uv.x*${ASPECT.toFixed(4)}, uv.y)*1.9;
  vec2 q = vec2(fbm(p+vec2(0.,t)), fbm(p+vec2(5.2,1.3)-t));
  vec2 r = vec2(fbm(p+3.*q+vec2(1.7,9.2)+.3*t), fbm(p+3.*q+vec2(8.3,2.8)));
  float f = fbm(p+2.6*r);
  float L = uv.y*3.6 + uv.x*1.3 + (f-.5)*5.2 + (r.x-.5)*2.2;
  float i0 = floor(L), fr = fract(L);
  vec3 col = mix(pal(i0), pal(i0+1.), smoothstep(.80,.97,fr));
  float vein = 1. - smoothstep(0., .045, abs(fract(f*9.+r.y*2.3)-.5));
  return mix(col, vec3(.97,.955,.86), vein*.8);`;
const VS = `attribute vec2 a; varying vec2 vUv; void main(){ vUv = a*.5+.5; gl_Position = vec4(a,0.,1.); }`;
const HEAD = `
#ifdef GL_FRAGMENT_PRECISION_HIGH
precision highp float;
#else
precision mediump float;
#endif
varying vec2 vUv;
const float C = 128.0/255.0;
float hash(vec2 p){ p = fract(p*vec2(123.34,456.21)); p += dot(p,p+45.32); return fract(p.x*p.y); }
float noise(vec2 p){ vec2 i=floor(p), f=fract(p); vec2 u=f*f*(3.-2.*f);
  return mix(mix(hash(i),hash(i+vec2(1.,0.)),u.x), mix(hash(i+vec2(0.,1.)),hash(i+vec2(1.,1.)),u.x), u.y); }
float fbm(vec2 p){ float v=0., a=.5; for(int i=0;i<5;i++){ v+=a*noise(p); p=p*2.03+vec2(1.7,9.2); a*=.5; } return v; }
${PALETTE === 'shop' ? MARBLE_SHOP : MARBLE_CLASSIC}
}`;
const FS_INIT = HEAD + `uniform float uTime; void main(){ gl_FragColor = vec4(marble(vUv,uTime),1.); }`;
const FS_VEL = HEAD + `
uniform sampler2D uVel; uniform vec2 uPos, uDelta; uniform float uActive, uRadius;
void main(){
  vec2 v = (texture2D(uVel,vUv).rg - C)/8.;
  vec4 a = texture2D(uVel, vUv - v*.8);
  v = (a.rg - C)/8.; float w = a.b;
  vec2 d = vUv - uPos; d.x *= ${ASPECT.toFixed(4)};
  float g = exp(-dot(d,d)/(uRadius*uRadius)) * uActive;
  v = v*.955 + uDelta*g*1.1;
  v = sign(v)*max(abs(v)-.0003, 0.);
  v = clamp(v, -.055, .055);
  w = max(w*.986 - .0018, 0.) + g*clamp(length(uDelta)*45., 0., 1.)*.3;
  gl_FragColor = vec4(v*8.+C, min(w,1.), 1.);
}`;
const FS_DYE = HEAD + `
uniform sampler2D uDye, uVel; uniform float uTime, uRelax, uActive; uniform vec2 uPos; uniform vec3 uInk;
void main(){
  vec2 v = (texture2D(uVel,vUv).rg - C)/8.;
  vec3 c = texture2D(uDye, vUv - v).rgb;
  c = mix(c, marble(vUv,uTime), uRelax);
  vec2 d = vUv - uPos; d.x *= ${ASPECT.toFixed(4)};
  float g = exp(-dot(d,d)/(.022*.022)) * uActive;
  c = mix(c, uInk, clamp(g,0.,1.)*.6);
  c += (hash(vUv*913.7 + fract(uTime*37.1)) - .5)/255.;
  gl_FragColor = vec4(c,1.);
}`;
const FS_SHOW = HEAD + `
uniform sampler2D uDye, uVel; uniform float uRest, uPanes; uniform vec2 uRes;
void main(){
  vec2 seed = vec2(vUv.x*${ASPECT.toFixed(4)}, vUv.y);
  vec2 off = (vec2(noise(seed*55.), noise(seed*55.+7.3)) - .5)*.004;
  vec3 c = texture2D(uDye, vUv + off).rgb;
  float w = texture2D(uVel, vUv).b;
  float lum = dot(c, vec3(.299,.587,.114));
  vec3 frosted = mix(vec3(lum), c, .34);
  frosted = mix(frosted, vec3(.98), .48);
  float reveal = smoothstep(0., 1., clamp(uRest + w*2.4, 0., 1.));
  vec3 col = mix(frosted, c, reveal);
  col += (hash(gl_FragCoord.xy) - .5)*.014;
  col *= 1. - .05*smoothstep(.2,1.,abs(vUv.x-.5)*2.);
  gl_FragColor = vec4(mix(vec3(1.), col, uPanes), 1.);
}`;
return { VS, FS_INIT, FS_VEL, FS_DYE, FS_SHOW };
};